import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default function NotAuthorizedModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Not Authorized</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You are not authorized to view this page. Please sign in to continue.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
